export type GamePosition = {
  vertical_location: number;
  horizontal_location: number;
};

function getGridPosition(row: HTMLElement, targetElement: HTMLElement): GamePosition | null {
  const games = Array.from(row.querySelectorAll<HTMLElement>('[data-game-id]'));
  if (!games.length) {
    return null;
  }

  let currOffset = games[0].offsetTop;
  let vertPos = 1;
  let horPos = 1;

  for (const game of games) {
    if (currOffset < game.offsetTop) {
      vertPos += 1;
      horPos = 1;
      currOffset = game.offsetTop;
    }
    if (game === targetElement) {
      return { vertical_location: vertPos, horizontal_location: horPos };
    }
    horPos += 1;
  }

  return null;
}

function getLobbyPosition(allRows: HTMLElement[], targetElement: HTMLElement): GamePosition | null {
  for (let rowIdx = 0; rowIdx < allRows.length; rowIdx++) {
    const row = allRows[rowIdx];
    const games = Array.from(row.querySelectorAll<HTMLElement>('[data-game-id]'));

    for (let i = 0; i < games.length; i++) {
      if (games[i] === targetElement) {
        return {
          vertical_location: rowIdx + 1,
          horizontal_location: i + 1,
        };
      }
    }
  }

  return null;
}

export function getGamePosition(gameElement: HTMLElement): GamePosition | null {
  const allRows = Array.from(document.querySelectorAll<HTMLElement>('[data-games-row]'));
  if (allRows.length === 0) {
    return null;
  }

  if (allRows.length === 1) {
    return getGridPosition(allRows[0], gameElement);
  }

  return getLobbyPosition(allRows, gameElement);
}
